import { Platform } from "react-native";

type RumAttributes = Record<string, unknown>;

type NativeRumModule = typeof import("expo-datadog");
type WebRumModule = typeof import("@datadog/browser-rum");

let nativeRum: NativeRumModule | null = null;
let webRum: WebRumModule | null = null;

const getNativeRum = () => {
  try {
    if (!nativeRum) {
      nativeRum = require("expo-datadog");
    }
  } catch {
    nativeRum = null;
  }

  return nativeRum;
};

const getWebRum = () => {
  try {
    if (!webRum) {
      webRum = require("@datadog/browser-rum");
    }
  } catch {
    webRum = null;
  }

  return webRum;
};

export const addCustomRumAction = (
  name: string,
  attributes?: RumAttributes,
) => {
  const payload = attributes ?? {};

  if (Platform.OS === "web") {
    const rum = getWebRum();
    rum?.datadogRum.addAction(name, payload);
    return;
  }

  const rum = getNativeRum();
  rum?.DdRum.addAction(rum.RumActionType.CUSTOM, name, payload).catch(
    () => null,
  );
};

// RUM errors are the only client-side signal indexed in prod: logger.warn is
// suppressed there (logger.ts shouldLog) and the web ddlogs shim is
// console-only, so anything that must be visible in Datadog goes through here.
export const addCustomRumError = (
  message: string,
  attributes?: RumAttributes,
) => {
  const payload = attributes ?? {};

  if (Platform.OS === "web") {
    const rum = getWebRum();
    rum?.datadogRum.addError(new Error(message), payload);
    return;
  }

  const rum = getNativeRum();
  rum?.DdRum.addError(message, rum.ErrorSource.SOURCE, "", payload).catch(
    () => null,
  );
};
